import { createContext, useContext } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export const PanelNavigatorContext = /*#__PURE__*/createContext(undefined);
export const PanelNavigatorProvider = ({
  panelStylesOverrides,
  children
}) => {
  return /*#__PURE__*/_jsx(PanelNavigatorContext.Provider, {
    value: {
      panelStylesOverrides
    },
    children: children
  });
};

/**
 * Provides the context for the `PanelNavigator` component.
 * Note: The context is only available when the `PanelNavigator` component is rendered as an ancestor.
 * @returns PanelNavigatorContext - The context for the `PanelNavigator` component.
 * @returns PanelNavigatorContext.panelStylesOverrides - Style overrides to be applied to the `Panel` component.
 */
export const usePanelPanelNavigatorContext = () => {
  const panelNavigatorContext = useContext(PanelNavigatorContext);
  return panelNavigatorContext;
};